/*
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:24:00
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-29 09:07:55
 * @Description: PC 官网 route list，路由顺序慎改，会影响到 menu 的定位
 */

const pcRoutes = [
  {
    path: '/',
    name: 'index',
    // route level code-splitting
    // this generates a separate chunk (index.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: { title: '首页' },
    component: () => import(/* webpackChunkName: "index" */ '@/pages/pc/index')
  },
  {
    path: '/perfect-select',
    name: 'perfect-select',
    redirect: '/perfect-select/project-list',
    meta: { title: '鲸鱼优选' },
    component: () => import(/* webpackChunkName: "perfect-select" */ '@/pages/pc/perfect-select'),
    children: [
      {
        path: 'project-list',
        name: 'project-list',
        meta: { title: '优选列表' },
        component: () =>
          import(/* webpackChunkName: "project-list" */ '@/pages/pc/perfect-select/project-list')
      },
      {
        path: 'number-one-list',
        name: 'number-one-list',
        meta: { title: '鲸鱼一号列表' },
        component: () =>
          import(
            /* webpackChunkName: "number-one" */ '@/pages/pc/perfect-select/project-list/number-one'
          )
      },
      {
        path: 'project-detail/:id/:flag',
        name: 'project-detail',
        meta: { title: '标的详情' },
        component: () =>
          import(
            /* webpackChunkName: "project-detail" */ '@/pages/pc/perfect-select/project-detail'
          )
      },
      {
        path: 'risk-tips',
        name: 'risk-tips',
        meta: { title: '风险提示' },
        component: () =>
          import(/* webpackChunkName: "risk-tips" */ '@/pages/pc/perfect-select/risk-tips')
      },
      {
        path: 'agreement',
        name: 'agreement',
        meta: { title: '借款协议' },
        component: () =>
          import(/* webpackChunkName: "agreement" */ '@/pages/pc/perfect-select/agreement')
      }
    ]
  },
  {
    path: '/information',
    name: 'information',
    redirect: '/information/bank-info',
    component: () => import(/* webpackChunkName: "information" */ '@/pages/pc/information/index'),
    children: [
      {
        path: 'bank-info',
        name: 'bank-info',
        meta: { title: '银行存管' },
        component: () => import(/* webpackChunkName: "about" */ '@/pages/pc/information/bank-info')
      },
      {
        path: 'check-info',
        name: 'check-info',
        meta: { title: '审核信息' },
        redirect: 'check-info/list',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/check-info/index'),
        children: [
          {
            path: 'list',
            name: 'check-info-list',
            meta: { title: '审核信息列表' },
            component: () =>
              import(/* webpackChunkName: "about" */ '@/pages/pc/information/check-info/list')
          },
          {
            path: 'fn-2016',
            name: 'fn-2016',
            meta: { title: '2016年财务报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/pc/information/check-info/financial-reports-2016'
              )
          },
          {
            path: 'fn-2017',
            name: 'fn-2017',
            meta: { title: '2017年财务报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/pc/information/check-info/financial-reports-2017'
              )
          },
          {
            path: 'fn-2018',
            name: 'fn-2018',
            meta: { title: '2018年财务报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/pc/information/check-info/financial-reports-2018'
              )
          },
          {
            path: 'sp-2018',
            name: 'sp-2018',
            meta: { title: '2018年专项审计报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/pc/information/check-info/special-reports-2018'
              )
          },
          {
            path: 'im-2019',
            name: 'im-2019',
            meta: { title: '2019年重点环节专项审计报告' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/pc/information/check-info/important-reports-2019'
              )
          }
        ]
      },
      {
        path: 'edu-for-lender',
        name: 'edu-for-lender',
        meta: { title: '出借人教育' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/edu-for-lender')
      },
      {
        path: 'importance-event',
        name: 'importance-event',
        meta: { title: '重大事项公布' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/importance-event')
      },
      {
        path: 'law',
        name: 'law',
        meta: { title: '法律法规' },
        component: () => import(/* webpackChunkName: "about" */ '@/pages/pc/information/law')
      },
      {
        path: 'operation-data',
        name: 'operation-data',
        meta: { title: '运营数据' },
        redirect: 'operation-data/current',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/operation-data'),
        children: [
          {
            path: 'current',
            name: 'current',
            meta: { title: '运营数据' },
            component: () =>
              import(
                /* webpackChunkName: "about" */ '@/pages/pc/information/operation-data/current'
              )
          },
          {
            path: 'total',
            name: 'total',
            meta: { title: '运营数据' },
            component: () =>
              import(/* webpackChunkName: "about" */ '@/pages/pc/information/operation-data/total')
          }
        ]
      },
      {
        path: 'organizetion',
        name: 'organizetion',
        meta: { title: '组织信息' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/organizetion')
      },
      {
        path: 'promise-file',
        name: 'promise-file',
        meta: { title: '合规经营承诺书' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/promise-file')
      },
      {
        path: 'records-info',
        name: 'records-info',
        meta: { title: '备案信息' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/records-info')
      },
      {
        path: 'risk-management',
        name: 'risk-management',
        meta: { title: '风险管理' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/risk-management')
      },
      {
        path: 'standard-for-charge',
        name: 'standard-for-charge',
        meta: { title: '收费标准' },
        component: () =>
          import(/* webpackChunkName: "about" */ '@/pages/pc/information/standard-for-charge')
      }
    ]
  },
  {
    path: '/party-index',
    name: 'party-index',
    redirect: '/about-us/party/list'
  },
  {
    path: '/about-us',
    name: 'about-us',
    redirect: '/about-us/company-info',
    component: () => import(/* webpackChunkName: "about-us" */ '@/pages/pc/about-us/index'),
    children: [
      {
        path: 'company-info',
        name: 'company-info',
        meta: { title: '公司简介' },
        component: () =>
          import(/* webpackChunkName: "company-info" */ '@/pages/pc/about-us/company-info')
      },
      {
        path: 'party',
        name: 'party',
        meta: { title: '党建工作' },
        redirect: 'party/list',
        component: () => import(/* webpackChunkName: "party" */ '@/pages/pc/about-us/party'),
        children: [
          {
            path: 'list',
            name: 'party-list',
            meta: { title: '党建工作' },
            component: () =>
              import(/* webpackChunkName: "party-list" */ '@/pages/pc/about-us/party/list')
          },
          {
            path: 'content/:id',
            name: 'party-content',
            meta: { title: '党建工作' },
            component: () =>
              import(/* webpackChunkName: "party-content" */ '@/pages/pc/about-us/party/content')
          }
        ]
      },
      {
        path: 'news',
        name: 'news',
        meta: { title: '鲸鱼动态' },
        redirect: 'news/list',
        component: () => import(/* webpackChunkName: "news" */ '@/pages/pc/about-us/news'),
        children: [
          {
            path: 'list',
            name: 'news-list',
            meta: { title: '鲸鱼动态' },
            component: () =>
              import(/* webpackChunkName: "news-list" */ '@/pages/pc/about-us/news/list')
          },
          {
            path: 'content/:id',
            name: 'news-content',
            meta: { title: '鲸鱼动态' },
            component: () =>
              import(/* webpackChunkName: "news-content" */ '@/pages/pc/about-us/news/content')
          }
        ]
      },
      {
        path: 'announcement',
        name: 'announcement',
        meta: { title: '鲸鱼公告' },
        redirect: 'announcement/list',
        component: () =>
          import(/* webpackChunkName: "announcement" */ '@/pages/pc/about-us/announcement'),
        children: [
          {
            path: 'list',
            name: 'announcement-list',
            meta: { title: '鲸鱼公告' },
            component: () =>
              import(
                /* webpackChunkName: "announcement-list" */ '@/pages/pc/about-us/announcement/list'
              )
          },
          {
            path: 'content/:id',
            name: 'announcement-content',
            meta: { title: '鲸鱼公告' },
            component: () =>
              import(
                /* webpackChunkName: "announcement-content" */ '@/pages/pc/about-us/announcement/content'
              )
          }
        ]
      },
      {
        path: 'cooperative-partner',
        name: 'cooperative-partner',
        meta: { title: '合作伙伴' },
        component: () =>
          import(
            /* webpackChunkName: "cooperative-partner" */ '@/pages/pc/about-us/cooperative-partner'
          )
      },
      {
        path: 'contact-us',
        name: 'contact-us',
        meta: { title: '联系我们' },
        component: () =>
          import(/* webpackChunkName: "contact-us" */ '@/pages/pc/about-us/contact-us')
      },
      {
        path: 'join-us',
        name: 'join-us',
        meta: { title: '加入我们' },
        component: () => import(/* webpackChunkName: "join-us" */ '@/pages/pc/about-us/join-us')
      }
    ]
  },
  // {
  //   path: '/borrowing',
  //   name: 'borrowing',
  //   meta: { title: '我要借款' },
  //   component: () => import(/* webpackChunkName: "borrowing" */ '@/pages/pc/borrowing')
  // }
  // {
  //   path: '/',
  //   name: 'index',
  //   redirect: '/count-pandect',
  //   component: r => require.ensure([], () => r(require('../views/pages/pc/index')), 'index'),
  //   meta: {
  //     title: '用户总览',
  //     requiresAuth: true
  //   },
  // }
];

export default pcRoutes;
